import { Directive, ComponentFactory, ComponentRef, Input, TemplateRef, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { LoadingTemplateComponent } from './components/loading-template/loading-template.component';

@Directive({
  selector: '[appLoader]'
})
export class LoadingDirective {
  loadingFactory : ComponentFactory<LoadingTemplateComponent>;
  loadingComponent : ComponentRef<LoadingTemplateComponent>;

  @Input() minusMargin = false;

  @Input() 
  set appLoading(loading: boolean) {
    this.vcRef.clear();

    if (loading)
    {
      // create and embed an instance of the loading component
      this.loadingComponent = this.vcRef.createComponent(this.loadingFactory);
      this.loadingComponent.instance.minusMargin = this.minusMargin;
    }
    /*else
    {
      // embed the contents of the host template
      this.vcRef.createEmbeddedView(this.templateRef);
    } */  
  }

  constructor(
    //private templateRef: TemplateRef<any>, 
    private vcRef: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver) {
    // Create resolver for loading component
    this.loadingFactory = this.componentFactoryResolver.resolveComponentFactory(LoadingTemplateComponent);
  }

}
